export default "__VITE_ASSET__HqVjFuLZ__"